import React from 'react'
const DialogAppInfo = props => {
    const { label, name, desc } = props
    return (
        <div className="track-body-title track-body-title-oneline">
            <span className="track-body-title-content">{label}</span>
            <span className="track-body-title-content">{name}</span>
            {desc ? <span className="track-body-title-desc">{desc}</span> : null}
        </div>
    )
}

export default DialogAppInfo
